module.exports = __webpack_public_path__ + "img/Luxembourg.882cbd4c.png";